import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { MoneyCashForm } from 'refunds/containers/MoneyCashForm/MoneyCashForm'
import type { MoneyCashInfo, RefundData } from 'refunds/types/refundData'

import style from './MoneyCashFormContainer.module.scss'
import text from 'fukku/styles/texts.module.scss'

interface MoneyCashFormContainerProps {
	readonly refundData?: RefundData
	readonly handleOnError?: () => void
	readonly handleOnSave?: (values: MoneyCashInfo) => void
	readonly showTitle?: boolean
}

export function MoneyCashFormContainer({
	refundData,
	handleOnError,
	handleOnSave,
	showTitle,
}: MoneyCashFormContainerProps) {
	const { t } = useLabels()

	return (
		<div className={style.content}>
			<div className={style.header}>
				{showTitle && (
					<p className={`${style.title} ${text.titleM}`}>
						{t('form.refunds.cash.refundInfo.title')}
					</p>
				)}
			</div>

			<MoneyCashForm
				preloadData={refundData}
				onError={handleOnError}
				onSaveData={handleOnSave}
			/>

			<div className={`${text.bodyS} ${style.details}`}>
				{t('myRefunds.bankDetails.checkDetails.text')}
			</div>
		</div>
	)
}
